import { useEffect, useState } from "react";
import { authFetch } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const short = (r) => `${String(r.section || "").replace(/^0/, "")} ${parseInt(r.numero, 10)}`;

/**
 * Références cadastrales de la parcelle, en une ligne sous son nom (en-tête du carnet).
 * Rien n'est affiché tant qu'elles ne sont pas connues (ou si l'IGN ne répond pas).
 */
export default function CadastreRefsLine({ parcelId, className = "" }) {
  const [refs, setRefs] = useState([]);
  useEffect(() => {
    if (!parcelId || !String(parcelId).includes("974")) return;
    let off = false;
    authFetch(`${API}/cadastre/parcel/${encodeURIComponent(parcelId)}`)
      .then((r) => (r.ok ? r.json() : { refs: [] }))
      .then((d) => { if (!off) setRefs(d.refs || []); })
      .catch(() => {});
    return () => { off = true; };
  }, [parcelId]);
  if (!refs.length) return null;
  const shown = refs.slice(0, 4).map(short).join(" · ");
  const title = refs.map((r) => `${short(r)} (${r.commune || r.code_insee})${r.share_of_parcel_pct != null ? ` · ${r.share_of_parcel_pct} %` : ""}`).join("\n");
  return (
    <div className={`text-[10.5px] truncate font-mono ${className}`} style={{ color: "#B4532F" }} title={title} data-testid="carnet-cadastre-refs">
      Cadastre : {shown}{refs.length > 4 ? ` +${refs.length - 4}` : ""}
    </div>
  );
}
